module.exports = __webpack_public_path__ + "img/West Wild Warriors.a8cc1bbd.png";